export const EMPTY_FLIGHTS_HOTELS_CHECK = 'Siamo spiacenti, nessuna soluzione disponibile per la data richiesta. Si suggerisce di modificare data o aeroporto di partenza.'
export const EMPTY_FLIGHTS_CHECK = 'Siamo spiacenti, nessun volo disponibile per la data richiesta. Si suggerisce di modificare data o aeroporto di partenza.'
export const EMPTY_HOTELS_CHECK = 'Siamo spiacenti, nessun hotel disponibile per la data richiesta. Si suggerisce di modificare la data di partenza.'
export const EMPTY_LIST = 'Lista vuota!'
export const ERROR_LOADING_CONFIG = 'Errore caricamento configurazioni!'
export const ERROR_SEARCH_NO_FLIGHT = 'Siamo spiacenti, nessuna soluzione disponibile per la data richiesta. Si suggerisce di modificare data o aeroporto di partenza.'
export const SUCCESS_FLIGHT_SELECTION = 'Volo selezionato!'
export const SUCCESS_SEARCH_MODIFICATION = 'Modifica della ricerca avvenuta con successo'
export const SUCCESS_HOTEL_ADD = 'Hotel aggiunto!'
export const SUCCESS_HOTEL_MODIFY = 'Hotel modificato!'
export const SUCCESS_SERVICE_ADD = 'Servizio aggiunto!'
export const SUCCESS_SERVICE_REMOVE = 'Servizio rimosso!'
export const SUCCESS_SERVICE_MODIFY = 'Servizio modificato!'
export const SUCCESS_TOUR_MODIFY = 'Tour modificato!'
export const SUCCESS_FILTER_RESET = 'Filtro azzerato!'
export const SUCCESS_EMAIL_SEND = 'Email spedita correttamente!'
export const SUCCESS_SELECTION = 'Elemento selezionato!'
export const MODIFY_SUCCESS = 'Le modifiche sono state correttamente recepite'
export const ERROR_GENERIC = 'Errore generico!'



// WEBPACK FOOTER //
// ./src/front/utils/messages.js